'use strict';

certificatesService.$inject = ["api", "config", "$stateParams", "CertificateItem", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.certificatesService = certificatesService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function certificatesService(api, config, $stateParams, CertificateItem, authService) {
    var baseUrl = config.webApiBaseUrl;

    return {
        searchCertificates: searchCertificates,
        getCoaUrl: getCoaUrl
    };

    function searchCertificates(search) {
        return api.certificates.search(search).$promise.then(function (response) {
            response.results = _lodash2.default.map(response.results, function (i) {
                return CertificateItem.create(i);
            });
            return response;
        });
    }
    function getCoaUrl(id) {
        return baseUrl + ('certificates/' + id + '/getCertificateOfAnalysis?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/certificatesService.js
// module id = 805
// module chunks = 0